module.exports = __webpack_public_path__ + "static/media/ic_save.f7d42a77.svg";